import React, { Component } from "react";
import { Link } from "react-router-dom";
import frontProjects from "../Data/frontend-projects";
import '../Styles/Projects.css';

export default class FrontProjects extends Component {
  render() {
    return (
      <section className="projects" id="projects">
        <div 
          className="projects-container"
          // data-aos="fade-up-right"
          // data-aos-duration="1000"
        >
          <h1 className="title-project">Projetos Front-End</h1>
          <div className="projects-content">

          {
            frontProjects.map((project) => (
              <div className="project" key={ project.name }>
                <div className="project-image">
                  <img src={ project.img } alt="project-logo" />
                </div>

                <div className="project-description">
                  <p>{ project.description }</p>
                </div>

                <div className="project-skills">
                  {
                    project.skills.name.map((skill, index) => (
                      <div className="project-skill" key={ index }>
                        { project.skills.icon[index] }
                        <p>{ skill }</p>
                      </div>
                    ))
                  }
                </div>

                <div className="project-button">
                  <Link
                    to={ `project/${project.name}` }
                    className="more-info"
                  >
                    Mais Informações
                  </Link>
                </div>
              </div>
            ))
          } 

          </div>
        </div>
    </section>
    )
  }
}

